import CommonList from '@/views/common/CommonList.vue'

export default [
    {
        // 常见问题列表
        path: '/common/list',
        name: 'CommonList',
        component: CommonList
    }
]
